module.exports = __webpack_public_path__ + "img/solution-1.5d4cc4d1.jpg";